import EditableGridRow from '../../components/EditableGridRow.vue'
import EditableGridCell from '../../components/EditableGridCell.vue'

export default {
  name: 'SpecialPromotionPartialView',

  props: {
    hideStartDate: {
      type: String
    },
    hideEndDate: {
      type: String
    },
    row: Number,
    activeRow: Number,
    activeColumn: Number,
    isBeingEdited: Boolean,
    disableDelete: {
      type: Boolean
    },
    item: {
      type: Object,
      required: true
    },
    itemIndex: {
      type: Number,
      required: true
    },
    promotion: {
      type: Object,
      required: true
    },
    customerGroups: {
      type: Array,
      required: true
    },
    $v: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      types: [
        {
          text: 'Buy x (PLU) and get y (PLU) reduced or Free',
          value: 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS'
        }, {
          text: 'Buy x (PLU) and get y (PLU) reduced or Free',
          value: 'BUY_ITEMS_GET_SUM_OFF_ITEMS'
        }, {
          text: 'Multi-buy',
          value: 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE'
        }, {
          text: 'Spend x$ and get y (PLU) Free or reduced price (% off)',
          value: 'SPEND_GET_PERCENTAGE_OFF_ITEMS'
        }, {
          text: 'Spend x$ and get y (PLU) Free or reduced price (sum of)',
          value: 'SPEND_GET_SUM_OFF_ITEMS'
        }, {
          text: 'Item % off',
          value: 'MULTIBUY_GET_PERCENTAGE_OFF'
        }, {
          text: 'Item $ off',
          value: 'MULTIBUY_GET_SUM_OFF'
        }
      ]
    }
  },

  computed: {
    basePrice () {
      console.log('basePrice')
      console.log(this.item)
      let regularPrice = this.item.regularPrice
      let regularCustomerGroupPrice = this.item.regularCustomerGroupPrice

      if (this.promotion.customerGroupId === 0) {
        return regularPrice
      } else {
        return regularCustomerGroupPrice
      }
    },

    customerGroupName () {
      return this.customerGroups.reduce((result, customerGroup) => {
        return customerGroup.value === this.promotion.customerGroupId ? customerGroup.text : result
      }, '')
    },

    discountedPrice () {
      console.log('discountedPrice')
      console.log(this.item)
      console.log(this.promotion)
      if (this.promotion.rewards.sumOff) {
        return this.basePrice - this.promotion.rewards.sumOff
      } else if (this.promotion.rewards.percentageOff) {
        return this.basePrice - this.basePrice * this.promotion.rewards.percentageOff / 100
      } if (this.promotion.rewards.specialUnitPrice) {
        return this.promotion.rewards.specialUnitPrice
      } else {
        return this.basePrice
      }
    },

    margin () {
      let salesPrice = parseFloat(this.discountedPrice)
      let cost = parseFloat(this.item.cost)

      if (isNaN(cost) || isNaN(salesPrice)) {
        return 0
      }

      if (salesPrice === 0) {
        return 0
      }

      return (salesPrice - cost) / salesPrice * 100
    },

    showDates () {
      return this.hideStartDate !== this.promotion.startDate || this.hideEndDate !== this.promotion.endDate
    },

    typeName () {
      let type = this.types.find(type => type.value === this.promotion.type)
      if (type) {
        return type.text
      } else {
        return ''
      }
    }
  },

  watch: {
    promotion: {
      deep: true,
      handler: function (val) {
        this.promotion.hasBeenEdited = true
      }
    }
  },

  components: {
    'editable-grid-row': EditableGridRow,
    'editable-grid-cell': EditableGridCell
  },

  methods: {
    deletePromotion () {
      this.$emit('delete-item', this.promotion)
    },

    showPromotion () {
      this.$emit('show-promotion', this.promotion)
    }
  },

  created () {
    this.$on('activated', (data) => {
      this.$parent.$emit('activated', data)
    })

    this.$on('edit', (data) => {
      this.$parent.$emit('edit', data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/views/EditEvent/SpecialPromotionItem.js